const LOGIN_PATH = '/login'
const LOGIN_API_HINT = '/api/crm/auth/login'
const LOCAL_ORIGIN = 'http://local.invalid'
const NAVIGATION_ABORTED = 4
const NAVIGATION_DUPLICATED = 16

export function isSafeInternalRedirect (value) {
  if (typeof value !== 'string' || value.length === 0) {
    return false
  }
  if (value.charAt(0) !== '/' || value.startsWith('//') || value.indexOf('\\') !== -1) {
    return false
  }

  try {
    const url = new URL(value, LOCAL_ORIGIN)
    if (url.origin !== LOCAL_ORIGIN) {
      return false
    }
    if (url.username || url.password) {
      return false
    }
    return url.pathname !== LOGIN_PATH
  } catch (e) {
    return false
  }
}

export function resolveLoginRedirect (queryRedirect) {
  if (!isSafeInternalRedirect(queryRedirect)) {
    return '/'
  }

  const url = new URL(queryRedirect, LOCAL_ORIGIN)
  if (url.pathname === LOGIN_PATH) {
    return '/'
  }

  return url.pathname + url.search + url.hash
}

export function shouldSkip401Redirect (requestUrl) {
  const url = requestUrl || ''
  return url.indexOf(LOGIN_API_HINT) !== -1
}

export function build401LoginLocation (currentRoute, pendingRoute = null) {
  const pendingRedirect = resolveRouteRedirect(pendingRoute)
  const currentRedirect = resolveRouteRedirect(currentRoute)
  const redirect = pendingRedirect !== '/' ? pendingRedirect : currentRedirect
  if (!redirect || redirect === '/') {
    return { path: LOGIN_PATH }
  }
  return { path: LOGIN_PATH, query: { redirect } }
}

export function isAuthNavigationCurrent (router, pendingRoute) {
  return !!router && router.authPendingRoute === pendingRoute
}

export function shouldRetainPermissionRouteOnLoadError (route, loadError) {
  return !!loadError && !!(route && route.meta && route.meta.retainOnPermissionLoadError)
}

function resolveRouteRedirect (route) {
  if (!route) {
    return '/'
  }
  if (route.path === LOGIN_PATH) {
    return resolveLoginRedirect(route.query && route.query.redirect)
  }
  return resolveLoginRedirect(route.fullPath)
}

export function clearExpiredLoginState (loginState, storage, resetPermissions) {
  if (loginState) {
    loginState.Jwt = null
    loginState.IsLogin = false
  }
  if (storage) {
    storage.removeItem('Jwt')
  }
  if (typeof resetPermissions === 'function') {
    resetPermissions()
  }
}

export async function navigateAfterLogin (router, target, reloadPage) {
  try {
    await router.push(target)
  } catch (error) {
    if (!error || error.type !== NAVIGATION_ABORTED) {
      throw error
    }

    const returnedToLoginAfterExpiry = router.currentRoute &&
      router.currentRoute.path === LOGIN_PATH &&
      !window.localStorage.getItem('Jwt')
    if (returnedToLoginAfterExpiry) {
      return
    }

    try {
      await router.push('/')
    } catch (fallbackError) {
      if (!fallbackError || fallbackError.type !== NAVIGATION_DUPLICATED) {
        throw fallbackError
      }
    }
  }
  if (typeof reloadPage === 'function') {
    reloadPage()
  }
}

export function isAuthenticatedRouteVisible (isLogin, route) {
  return !!isLogin && !(route && route.path === LOGIN_PATH)
}

export function isDesktopChromeVisible (isLogin, route) {
  return isAuthenticatedRouteVisible(isLogin, route) &&
    !(route && route.meta && route.meta.hideDesktopChrome)
}

export function waitForInitialNavigation (router) {
  if (!router || typeof router.onReady !== 'function') {
    return Promise.resolve()
  }

  return new Promise(resolve => {
    router.onReady(resolve, resolve)
  })
}
